import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Down } from "../../../assets/svgIcon/listView/Down";
import { ReactComponent as DeleteRowIcon } from "../../../assets/svgIcon/shipment/DeleteRow.svg";
import { InputText } from "../../../components/InputText/InputText";
import { PopupModal } from "../../../components/TopBar/PopupModal/PopupModal";
import { DropDown, SearchDropDown } from "../DropDown/DropDown";
import {
  ALLOCATED_TO,
  BILL_STATUS_FOR_RULE,
  PURCHASE_ORDER_PAYMENT_STATUS_OPTIONS,
  idsForCurrencyField,
  idsForMultiSelectField,
  idsForProductField,
  idsForStatusField,
  idsForSupplierField,
  idsForWarehousField,
  numericFieldIds,
} from "./constant";

export const FilterForOneField = ({
  ind,
  setDropDownValues,
  handleAddMoreCriteria,
  dropDownValues,
  allocation,
  setPatternAfterDeletion,
}) => {
  const { allFilterCondition, allFilterField, statusForFilter } = useSelector(
    state => state.newInterface,
  );
  const { supplier, warehouse, products } = useSelector(state => state.report);
  const { currenciesSelection } = useSelector(state => state.currency);
  const { transferOrdersSelection } = useSelector(state => state.order);
  const { purchaseOrdersSelection } = useSelector(state => state.purchaseOrder);
  const [filteredCondition, setFilteredCondition] = useState(allFilterCondition);
  const [isStatusDropDownOpen, setIsStatusDropDownOpen] = useState(false);
  const selectedFilterField = allFilterField.find(item => item.id === dropDownValues[ind]["field"]);
  const isWarehouseRuleField =
    idsForWarehousField.includes(dropDownValues[ind]["field"]) ||
    /warehouse/i.test(selectedFilterField?.lookup || "") ||
    /warehouse|facility/i.test(selectedFilterField?.name || "");
  const isPaymentStatusRuleField = selectedFilterField?.lookup === "payment_status";
  const isNumericPaymentRuleField = ["total_amount", "total_payments_allocated", "payment_outstanding"].includes(
    selectedFilterField?.lookup,
  );
  const isMultiSelectRuleField =
    idsForMultiSelectField.includes(dropDownValues[ind]["field"]) ||
    isWarehouseRuleField ||
    isPaymentStatusRuleField;

  const [selectedStatusItems, setSelectedStatusItems] = useState(
    isMultiSelectRuleField ? dropDownValues[ind].value : [],
  );

  useEffect(() => {
    const filteredField = allFilterField.find(item => item.id === dropDownValues[ind]["field"]);

    if (filteredField)
      setFilteredCondition(
        allFilterCondition.filter(item => filteredField.conditions.includes(item.id)),
      );

    if (isMultiSelectRuleField) {
      setSelectedStatusItems(dropDownValues[ind].value);
    }
    // eslint-disable-next-line
  }, [dropDownValues[ind]["field"], allFilterCondition, allFilterField]);

  const handleInputValue = e => {
    setDropDownValues(state => {
      const allData = state.map((item, indexOfItem) =>
        indexOfItem === ind ? { ...item, value: e.target.value } : item,
      );
      return allData;
    });
  };

  const handleSelectStatusOption = e => {
    const val =
      numericFieldIds.includes(dropDownValues[ind].field) ||
      isWarehouseRuleField ||
      isNumericPaymentRuleField
        ? Number(e.target.value)
        : e.target.value;
    let items = [...selectedStatusItems];
    if (e.target.checked) {
      items.push(val);
    } else {
      items = items.filter(item => item !== val);
    }

    setSelectedStatusItems(items);
    const allValues = [...dropDownValues];
    allValues[ind]["value"] = items;
    setDropDownValues(allValues);
  };

  const selectItemsForMultiselect = () => {
    const idOfSelectedField = dropDownValues[ind].field;
    //for status
    if (idsForStatusField.includes(idOfSelectedField)) {
      return statusForFilter;
    } else if (idsForSupplierField.includes(idOfSelectedField)) {
      return supplier;
    } else if (isWarehouseRuleField) {
      return warehouse;
    } else if (idsForProductField.includes(idOfSelectedField)) {
      return products.map(product => ({ id: product.id, name: product.number }));
    } else if ([31].includes(idOfSelectedField)) {
      return allocation === "purchase" ? purchaseOrdersSelection : transferOrdersSelection;
    } else if ([35].includes(idOfSelectedField))
      return [
        { id: "Purchase Receipt", name: "Purchase Receipt" },
        { id: "Transfer Receipt", name: "Transfer Receipt" },
      ];
    else if (idsForCurrencyField.includes(idOfSelectedField)) {
      return currenciesSelection;
    } else if ([37].includes(idOfSelectedField)) {
      return BILL_STATUS_FOR_RULE;
    } else if ([36].includes(idOfSelectedField)) {
      return ALLOCATED_TO;
    } else if (selectedFilterField?.lookup === "payment_status") {
      return PURCHASE_ORDER_PAYMENT_STATUS_OPTIONS;
    } else {
      return [];
    }
  };

  const deleteRowOfFilter = () => {
    if (ind === 0 && dropDownValues.length === 1) return;
    const valuesAfterDeletion = dropDownValues
      .filter((_, index) => ind !== index)
      .map((item, dropInd) => ({ ...item, index: dropInd + 1 }));
    let newPattern = 1;
    if (valuesAfterDeletion.length !== 1) {
      valuesAfterDeletion.forEach((item, ind) => {
        if (ind !== valuesAfterDeletion.length - 1) {
          newPattern = "(" + newPattern + " " + item["criteria"] + " " + (ind + 2) + ")";
        }
      });
    }

    setPatternAfterDeletion(newPattern);
    setDropDownValues(valuesAfterDeletion);
  };

  const closeStatusDropDown = () => {
    setIsStatusDropDownOpen(false);
  };

  return (
    <div key={ind} className="filterForColumn search-dropdown-container">
      <SearchDropDown
        index={ind}
        handleDropDown={setDropDownValues}
        isObject={true}
        allData={allFilterField}
        isSelected={allFilterField.find(item => item.id === dropDownValues[ind].field)?.name}
        fieldName="Field"
      />
      <SearchDropDown
        index={ind}
        handleDropDown={setDropDownValues}
        isObject={true}
        allData={filteredCondition}
        isSelected={filteredCondition.find(item => item.id === dropDownValues[ind].condition)?.name}
        fieldName="Condition"
      />
      {isMultiSelectRuleField ? (
        <DropDown className="search-dropdown-container">
          <label className="search-dropdown-label">Value</label>
          <div
            className="search-dropdown-header"
            onClick={() => setIsStatusDropDownOpen(!isStatusDropDownOpen)}
          >
            {selectedStatusItems.length > 0 ? "Selected" : "Select"}
            <Down />
          </div>
          {isStatusDropDownOpen && (
            <StatusDropDown
              statusWithId={selectItemsForMultiselect()}
              handleSelectStatusOption={handleSelectStatusOption}
              dropDownValues={dropDownValues[ind].value}
              closeStatusDropDown={closeStatusDropDown}
            />
          )}
        </DropDown>
      ) : (
        <InputText
          labelOfInput="Value"
          placeholder="Type value here"
          text={dropDownValues[ind].value}
          setText={handleInputValue}
        />
      )}
      <SearchDropDown
        index={ind}
        handleDropDown={setDropDownValues}
        options={["OR", "AND"]}
        fieldName="Criteria"
        handleAddMoreCriteria={handleAddMoreCriteria}
        isSelected={dropDownValues[ind].criteria}
      />

      <span className="iconWrapper deleteRow" title="Delete Row" onClick={deleteRowOfFilter}>
        <DeleteRowIcon />
      </span>
    </div>
  );
};

export const StatusDropDown = ({
  statusWithId,
  handleSelectStatusOption,
  dropDownValues,
  index,
  closeStatusDropDown,
}) => {
  return (
    <PopupModal closeModal={closeStatusDropDown}>
      <div className="search-dropdown-menu">
        <ul className="search-dropdown-options">
          {statusWithId?.map(item => (
            <LabelForStatus className="search-dropdown-option" key={item.id}>
              <input
                type="checkbox"
                onChange={e => handleSelectStatusOption(e, index)}
                checked={dropDownValues ? dropDownValues?.some(id => id === item.id) : false}
                value={item.id}
              />
              {item.name}
            </LabelForStatus>
          ))}
        </ul>
      </div>
    </PopupModal>
  );
};

const LabelForStatus = styled.label`
  justify-content: start !important;
  gap: 8px;
`;
